import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssetDto, GalleryAccessLevel, TagDto } from '@picflow/types';
import { AssetTagService } from 'src/app/asset-tag.service';
import { TagService } from 'src/app/tag.service';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';

@Component({
  selector: 'app-asset-tags',
  templateUrl: './asset-tags.component.html',
  styleUrls: ['./asset-tags.component.scss'],
  standalone: true,
  imports: [NgFor, FormsModule, ReactiveFormsModule, InputFieldComponent, AsyncPipe, NgIf],
})
export class AssetTagsComponent {
  @Input() asset: AssetDto;
  @Input() accessLevel: GalleryAccessLevel;

  addTagForm = new FormGroup({
    name: new FormControl(''),
    category: new FormControl(''),
  });

  constructor(public tagService: TagService, private assetTagService: AssetTagService) {
    if (this.accessLevel === 'edit') {
      this.tagService.getTags();
    }
  }

  async addTag() {
    if (!this.addTagForm.valid) return;
    this.tagService.createTag(this.addTagForm.value.name, this.addTagForm.value.category);
  }

  async addTagToAsset(tag: TagDto) {
    if (this.asset['tags'].find(t => t.id === tag.id)) return;
    await this.assetTagService.add(this.asset.id, tag.id);
    this.asset['tags'].push(tag);
  }

  async removeTagFromAsset(tag: TagDto) {
    await this.assetTagService.remove(this.asset.id, tag.id);
    this.asset['tags'] = this.asset['tags'].filter(t => t.id !== tag.id);
  }

  async deleteTag(tag: TagDto) {
    this.tagService.deleteTag(tag.id);
    this.asset['tags'] = this.asset['tags'].filter(t => t.id !== tag.id);
  }
}
